<div id="spinner" class="contenido" *ngIf="getIsLoading()">
  <div style="width: 3rem; height: 3rem;" class="spinner-border text-primary spinerCarga" role="status">
  </div>
</div>